/**
 * Date-extensions locale Kyrgyz [ky]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('ky', {
    monthNames: ['январь','февраль','март','апрель','май','июнь','июль','август','сентябрь','октябрь','ноябрь','декабрь'],
    monthShortNames: ['янв','фев','март','апр','май','июнь','июль','авг','сен','окт','ноя','дек'],
    dayNames: ['Жекшемби','Дүйшөмбү','Шейшемби','Шаршемби','Бейшемби','Жума','Ишемби'],
    dayShortNames: ['Жек','Дүй','Шей','Шар','Бей','Жум','Ише']
});
